module.exports = __webpack_public_path__ + "static/GTSuperDisplay-Regular-a686347bad5db8719eacbd12d3aa8ea4.ttf";